import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

/**
 * Assessment Container layout (AO-3.1 / ADR-AO-021) — ASW-1 managed shell host.
 *
 * Sibling surface to StudentLayout — intentionally does NOT use
 * BaseDashboardLayout, Sidebar, or application-shell chrome.
 * Surfaces use EF Foundation Slice palette tokens via theme.
 */
export default function AssessmentContainerLayout({ children }) {
  return (
    <Box
      component="main"
      data-assessment-container-layout
      data-assessment-workspace-layout
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: (theme) => theme.palette.ef?.canvas ?? 'background.default',
        color: 'text.primary',
        overflowX: 'hidden',
      }}
    >
      {children ?? <Outlet />}
    </Box>
  );
}
